<template>
  <section
    :class="{
      'flip-card-component my-9': true,
    }"
  >
    <Padding :padding="padding">
      <div
        :class="{
          'container mx-auto': true,
        }"
      >
        <FlipCards
          v-if="flipCards"
          v-bind="flipCards"
        />
      </div>
    </Padding>
  </section>
</template>
<script setup lang="ts">
import Padding from '~/components/Atoms/Padding/Padding.vue';
import FlipCards from '~/components/Atoms/FlipCard/FlipCards.vue';
import type { PortableTextFlipCards } from '~/sanity/types';

defineProps<PortableTextFlipCards>();
</script>

<style scoped></style>
